import { IManagingWindowsServiceInstance } from '../../api/models';
import { AppEnvironment } from '../../constants/AppEnvironment';
import { WindowsServiceStartType } from '../../constants/WindowsServiceStartType';
import { WindowsServiceState } from '../../constants/WindowsServiceState';
import { IStyledText, StyledText } from '../UIExtentions/Text';

function GetStateProps(state: string, startType: string, environment: AppEnvironment): IStyledText {
    const calculateVariant = (className: string) => {
        if (startType === WindowsServiceStartType.Disabled) {
            return state === WindowsServiceState.ServiceRunning ? 'text-orange' : 'text-muted';
        }
        return className;
    };

    switch (state) {
        case WindowsServiceState.ServiceRunning:
            return {
                text: 'Running',
                className: calculateVariant('text-success'),
            };
        case WindowsServiceState.ServiceStopped:
            return {
                text: 'Stopped',
                className: environment === AppEnvironment.Production ? calculateVariant('text-danger') : null,
            };
        case WindowsServiceState.ServiceStartPending:
            return {
                text: 'Start Pending',
                className: calculateVariant('text-orange'),
            };
        case WindowsServiceState.ServiceStopPending:
            return {
                text: 'Stop Pending',
                className: calculateVariant('text-orange'),
            };
        default:
            return {
                text: state,
            };
    }
}

export default function WindowsServiceStateText(serverApp: IManagingWindowsServiceInstance) {
    const stateProps = GetStateProps(serverApp.state, serverApp.startType, serverApp.environment as AppEnvironment);

    return <StyledText {...stateProps} />;
}
